// extracted by mini-css-extract-plugin
module.exports = {"list":"tabs_list__3aJ3B","item":"tabs_item__2sUCf","active":"tabs_active__1tCeP"};